<div class="content-block">

  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h2>Gestione <b> Parametri </b></h2>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Tabelle</li>
            <li class="breadcrumb-item active">Parametri</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <section class="col-md-12">

    <div class="card">
      <div class="card-header primary">
        <h3 class="card-title">
          <i class="fa fa-chart-pie mr-1"></i>
        </h3>

      </div><!-- /.card-header -->
      <div class="card-body">

        <dx-data-grid 
          [dataSource]="dataSource" 
          [showBorders]="true" 
          [focusedRowEnabled]="false" 
          [focusedRowIndex]="0"
          [allowColumnResizing]="true" 
          [columnAutoWidth]="true" 
          [columnResizingMode]="'widget'" 
          [showColumnLines]="true"
          [showRowLines]="true" 
          [rowAlternationEnabled]="true" 
          [allowColumnReordering]="true" 
          [wordWrapEnabled]="true"
          (onEditorPreparing)="onEditorPreparing($event)" 
          (onExporting)="onExporting($event)">

          <dxo-export [enabled]="true"></dxo-export>
          <dxo-editing mode="row" [allowAdding]="true" [allowUpdating]="true" [allowDeleting]="true" [useIcons]="true">
            <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
          </dxo-editing>

          <dxo-paging [pageSize]="10"></dxo-paging>

          <dxo-pager [showPageSizeSelector]="true" [showInfo]="true" [allowedPageSizes]="[5, 10, 20, 50]"></dxo-pager>

          <dxo-filter-row [visible]="true"></dxo-filter-row>

          <dxo-scrolling mode="standard"></dxo-scrolling>

          <dxi-column type="buttons" [buttons]="['edit', 'delete']"></dxi-column>

          <dxi-column dataField="nome" [visible]="true" width="250">

          </dxi-column>

          <dxi-column dataField="valNum" caption="Valore Numerico" alignment="left" width="100">
          </dxi-column>

          <dxi-column dataField="valBool" caption="Valore Booleano (Sì o No)" width="100">
          </dxi-column>

          <dxi-column dataField="valStr" caption="Valore Stringa">
          </dxi-column>

        </dx-data-grid>

      </div>
    </div>
  </section>
</div>